import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import { MapPinned } from 'lucide-react'
import { SectionHeading, EmptyState } from 'components/Erp/Presentation'
import { MapContainer, TileLayer, Marker, Popup } from 'localization/LocalizedLeaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import styles from '../ReportsPage.module.scss'

const ChppsMapView = ({ chpps = [], branches = [] }) => {
  useInterfaceLanguage();
  // Filter branches that belong to CHPP ONLY and have valid geo coordinates
  const branchesWithGeo = branches.filter(br => {
    if (!br.chpp || !br.geo) return false
    const coords = br.geo.split(',').map(s => parseFloat(s.trim()))
    return coords.length === 2 && !coords.some(isNaN)
  })

  if (branchesWithGeo.length === 0) {
    return (
      <div className={styles.panel} style={{ marginTop: 20 }}>
        <div className={styles.panelHeader}>
          <SectionHeading icon={MapPinned} title={<>{tr("Карта филиалов ТЭЦ")}</>} />
        </div>
        <div className={styles.panelBody}>
          <EmptyState icon={MapPinned} title={tr("Нет объектов с геолокацией")} description={tr("Нет филиалов ТЭЦ с геолокацией для отображения на карте")} compact />
        </div>
      </div>
    )
  }

  // Calculate center of all points
  const allCoords = branchesWithGeo.map(br => {
    const coords = br.geo.split(',').map(s => parseFloat(s.trim()))
    return coords
  })
  const centerLat = allCoords.reduce((sum, c) => sum + c[0], 0) / allCoords.length
  const centerLng = allCoords.reduce((sum, c) => sum + c[1], 0) / allCoords.length

  // Границы Кыргызстана
  const kyrgyzstanBounds = [
    [39.172, 69.276], // Southwest
    [43.238, 80.283]  // Northeast
  ]

  // Custom marker icon
  const markerIcon = new L.Icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  })

  const getChppName = (br) => {
    const chpp = chpps.find(c => c.id === br.chpp)
    return chpp ? chpp.name : tr("ТЭЦ")
  }

  return (
    <div className={styles.panel} style={{ marginTop: 20 }}>
      <div className={styles.panelHeader}>
        <SectionHeading icon={MapPinned} title={<>{tr("Карта филиалов ТЭЦ (")}{tr(branchesWithGeo.length)})</>} />
      </div>
      <div className={styles.panelBody}>
        <div style={{ height: 500, width: '100%' }}>
          <MapContainer center={[centerLat, centerLng]} zoom={10} minZoom={7} maxBounds={kyrgyzstanBounds} maxBoundsViscosity={1.0} style={{ height: '100%', width: '100%' }} attributionControl={false} zoomControl={false}>
            <TileLayer 
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              attribution="&copy; Esri"
              maxZoom={19}
            />
            <TileLayer 
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution=""
              maxZoom={19}
              opacity={0.65}
            />
            {branchesWithGeo.map(br => {
              const coords = br.geo.split(',').map(s => parseFloat(s.trim()))
              const chppName = getChppName(br)
              return (
                <Marker key={br.id} position={coords} icon={markerIcon}>
                  <Popup>
                    <div>
                      <strong>{tr(br.address || tr("Адрес не указан"))} - {tr(chppName)}</strong>
                      <br />{tr("Филиал: ")}{tr(br.name)}
                      <br />{tr("Координаты: ")}{tr(br.geo)}
                    </div>
                  </Popup>
                </Marker>
              )
            })}
          </MapContainer>
        </div>
      </div>
    </div>
  )
}

export default ChppsMapView
